import { ChevronRight } from 'lucide-react';
import type { HTMLProps, ReactElement } from 'react';

export interface AccordionProps extends HTMLProps<HTMLDivElement> {
  label: string;
  open: boolean;
  setOpen: (state: boolean) => void;
  defaultOpen?: boolean;
  icon?: ReactElement;
  headerClassName?: string;
}

export default function Accordion({
  label,
  icon,
  open,
  setOpen,
  defaultOpen = true,
  className,
  headerClassName,
  children,
  ...props
}: AccordionProps) {
  return (
    <div className={`rounded ${className}`} {...props}>
      <div
        className="flex items-center justify-between truncate rounded-md bg-gray-100 px-5 py-3 hover:cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <div className="flex flex-row items-center">
          {icon}
          <label
            className={`font-medium ${headerClassName}`}
          >{`${label}`}</label>
        </div>
        <span
          className={`flex items-center justify-center transition-transform ${
            open && 'rotate-90'
          }`}
        >
          <ChevronRight />
        </span>
      </div>
      <div
        className={`grid overflow-hidden transition-[grid-template-rows_300ms] ${
          open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="min-h-0">{children}</div>
      </div>
    </div>
  );
}
